// extracted by mini-css-extract-plugin
module.exports = {"accordionItem":"AccordionItem_accordionItem__Xg4Gj","accordionContent":"AccordionItem_accordionContent__8GV6x","accordionTrigger":"AccordionItem_accordionTrigger__DaqNn"};